import {useLocation, useNavigate} from "react-router-dom";
import Header from "../../components/header";
import { useState} from "react";
import Loader from "../../components/loader";
import Approval from "../../components/object/approval";

export default ({verified, selectedObject}) => {
    const object = selectedObject || useLocation().state.object;
    const[loading,setLoading] = useState(false)
    return <div className={"page"}>
        <Loader visible={loading}/>
        <Header title={"Оплата"}/>
        <Approval verified={verified} object={object} loading={loading} setLoading={setLoading}/>
    </div>
}
